<app-header></app-header>
<div class="container margin-top-70">
  <div class="row">
    <div class="col-md-6 mt-6">
      <table class="table table-bordered">
        <tbody>
          <tr>
            <td class="v-align-m">
              Announced Start Date
            </td>
            <td>
              <app-date-select
                class="form-control"
                [additionalClasses]="'float-left'"
                type="announcedStartDate"
                (dateSelected)="updateSelectedDate($event)"
              ></app-date-select>
            </td>
          </tr>

          <tr>
            <td class="v-align-m">
              Announced End Date
            </td>
            <td>
              <app-date-select
                class="form-control"
                [additionalClasses]="'float-left'"
                type="announcedEndDate"
                (dateSelected)="updateSelectedDate($event)"
              ></app-date-select>
            </td>
          </tr>
        </tbody>
      </table>
    </div>

    <div class="col-md-6 mt-6">
      <table class="table table-bordered">
        <tbody>
          <tr>
            <td class="v-align-m">
              Contracted Start Date
            </td>
            <td>
              <app-date-select
                class="form-control"
                [additionalClasses]="'float-left'"
                type="contractedStartDate"
                (dateSelected)="updateSelectedDate($event)"
              ></app-date-select>
            </td>
          </tr>

          <tr>
            <td class="v-align-m">
              Contracted End Date
            </td>
            <td>
              <app-date-select
                class="form-control"
                [additionalClasses]="'float-left'"
                type="contractedEndDate"
                (dateSelected)="updateSelectedDate($event)"
              ></app-date-select>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</div>

<div class="container table-responsive mt-2">
  <div class="d-grid gap-2 d-md-flex justify-content-md-end">
    <button
      [disabled]="showSearchLoading"
      type="submit"
      class="btn btn-primary btn-pkt"
      (click)="searchProduct()"
    >
      {{searchBtnText}}
      <i class="bi bi-search ps-1" *ngIf="!showSearchLoading"></i>
      <span
        *ngIf="showSearchLoading"
        class="spinner-border spinner-border-sm"
        role="status"
        aria-hidden="true"
      ></span>
    </button>
    <button
      class="btn btn-primary btn-pkt"
      type="button"
      (click)="downloadReport()"
    >
      <i class="fa fa-download"></i> Download
    </button>
    <button class="btn btn-primary btn-pkt" (click)="clearFilters()">
      Reset<i class="bi bi-trash ps-1"></i>
    </button>
  </div>
</div>

<div>
  <div class="container" style="overflow-x: scroll;">
    <table
      class="table table-hover table-bordered table-striped mt-2 pkt-table-style"
    >
      <thead class="thead-dark">
        <tr>
          <th scope="col" class="table-width-10">Product Id</th>
          <th scope="col" class="table-width-10">Title</th>
          <th scope="col" class="table-width-10">Announced Date</th>
          <th scope="col" class="table-width-10">Contracted Date</th>
          <th scope="col" class="table-width-10">Status</th>
          <th scope="col" class="table-width-10">PI Status</th>
          <th scope="col" class="table-width-10">Type</th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let product of products; let i = index;">
          <td>{{ product.part_number}}</td>
          <td>{{ product.name}}</td>
          <td>{{ product.announcement_date}}</td>
          <td>{{ product.contracted_date}}</td>
          <td>{{ product.status_name}}</td>
          <td>{{ product.pistatus}}</td>
          <td>{{ product.product_type_name}}</td>
        </tr>
      </tbody>
    </table>
  </div>
</div>
<div class="container">
  <app-pagination
    [maxSize]="maxSize"
    [pageSize]="pageSize"
    [collectionSize]="totalProducts"
    (pageChanged)="updatePageData($event)"
  ></app-pagination>
</div>
